<template>
  <VSnackbar
    :value="!!errors.length"
    :timeout="0"
    bottom
    multi-line
    @input="$event ? null : $store.commit('snackbar/close')"
  >
    <VRow dense>
      <VCol
        v-for="error in errors"
        :key="error.id"
        cols="12"
        class="py-0"
      >
        <VRow
          dense
          class="flex-nowrap"
        >
          <VCol
            class="align-self-center py-0"
          >
            <span
              class="d-inline-block text-truncate"
              style="max-width: 424px; white-space: normal !important"
              v-text="error.message"
            />
          </VCol>
          <VCol
            class="py-0 align-center d-flex"
            style="flex: 0 0 36px"
          >
            <VBtn
              color="white"
              icon
              class="ma-0"
              @click="$store.commit('snackbar/hideError', error)"
            >
              <VIcon>mdi-close</VIcon>
            </VBtn>
          </VCol>
        </VRow>
      </VCol>
      <VCol
        v-if="errors.length > 2"
        cols="12"
        class="align-self-center"
      >
        <VBtn
          text
          block
          color="white"
          class="ma-0"
          @click="$store.commit('snackbar/close')"
        >
          <VIcon>mdi-close</VIcon>
          Скрыть все
        </VBtn>
      </VCol>
    </VRow>
  </VSnackbar>
</template>

<script>
export default {
  name: 'SnackBar',
  computed: {
    errors() { return this.$store.state.snackbar.errors },
  },
}
</script>
